export const LIB_VERSION = '16.1.6'; // autogenerated 
//# sourceMappingURL=version.js.map